import script from "./indexDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./indexDetail.vue?vue&type=script&setup=true&lang=js"

import "./indexDetail.vue?vue&type=style&index=0&id=bb1e7194&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb1e7194"]])

export default __exports__